import { createBrowserHistory } from 'history';
import { getAppConfig } from '@telescope/cassini-utilities';

const { basename } = getAppConfig();

export default createBrowserHistory({ basename });